import { AxiosError } from 'axios';
import { ReactNode, useState } from 'react';
import { IErrorNotification } from '../commons/interfaces/apiError.interface';
import APIErrorContext from '../contexts/apiError.context';

const APIErrorProvider = ({ children }: { children: ReactNode }) => {
  const [error, setError] = useState<IErrorNotification | null>(null);

  const addError = (message: string, status: string) => setError({ message, status });

  const removeError = () => setError(null);

  const showError = (err: Error) => {
    if (err instanceof AxiosError) {
      const { response } = err;
      addError(response?.data.message, 'danger');
    }
  };

  const showMessage = (message: string) => {
    addError(message, 'success');
  };

  const value = { error, addError, removeError, showError, showMessage };

  return <APIErrorContext.Provider value={value}>{children}</APIErrorContext.Provider>;
};

export default APIErrorProvider;
